import * as Yup from 'yup'
import dayjs from 'dayjs'
import { getExpirationMaxDate, MAX_DATE_ERROR } from 'src/utils/expirationDateUtils'
import { ApproveStepAction } from './ApproveStepForm.interface'

export const getApproveStepFormSchema = (isExpirationRequired: boolean) => {
  const expiresAtSchema = Yup.string()
    .nullable()
    .test(
      'expires-after-effective',
      'Expiration date must be after effective date',
      (value, context) => {
        if (!value) {
          return true
        }

        const { effectiveAt } = context.parent

        if (!effectiveAt) {
          return true
        }

        return dayjs(value).isAfter(dayjs(effectiveAt), 'day')
      },
    )

  return Yup.object().shape({
    action: Yup.string()
      .oneOf([ApproveStepAction.Immediately, ApproveStepAction.Choose])
      .required(),
    effectiveAt: Yup.string()
      .nullable()
      .when('action', {
        is: ApproveStepAction.Choose,
        then: (schema) => schema.required('Effective date is required'),
        otherwise: (schema) => schema.nullable(),
      }),
    expiresAt: isExpirationRequired
      ? expiresAtSchema
          .required('Expiration date is required')
          .test('expires-in-future', 'Expiration date cannot be in the past', (value) => {
            return !value || !dayjs(value).isBefore(dayjs(), 'day')
          })
          .test('expires-within-max', MAX_DATE_ERROR, (value) => {
            return !value || !dayjs(value).isAfter(getExpirationMaxDate(), 'day')
          })
      : expiresAtSchema,
  })
}
